import React, { useState, useEffect, Fragment } from 'react';
import HelpIcon from '@material-ui/icons/Help';
import { Link } from 'react-router-dom';
import {
  Menu,
  MenuItem,
  IconButton,
  List,
  ListItem,
  Collapse,
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { useRootStore } from '../../stores/BridgeProvider';

export default function HelpButton() {
  const [subOpen, setSubOpen] = React.useState(false);
  const { joyrideStore } = useRootStore();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const locationPath = window.location.pathname.split('/')[1];
  const { jRID } = joyrideStore;

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubOpen(false);
  };
  const startTour = e => {
    e.stopPropagation();
    handleClose();
    joyrideStore.restart();
  };
  const handleClick = e => {
    e.stopPropagation();
    setSubOpen(prev => !prev);
  };

  return (
    <div>
      <IconButton onClick={handleMenu} color="inherit">
        <HelpIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem divider>
          <a
            style={{ color: '#263238', textDecoration: 'none' }}
            href="https://support.dealmap.com/support/home"
            target="_blank"
            rel="noopener noreferrer"
          >
            Help Articles
          </a>
        </MenuItem>
        <MenuItem divider>
          <a
            style={{ color: '#263238', textDecoration: 'none' }}
            href="https://support.dealmap.com/support/tickets/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Support
          </a>
        </MenuItem>
        {jRID === locationPath && (
          <MenuItem button onClick={e => handleClick(e)} divider={subOpen}>
            Guided Tour
            {subOpen ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>
        )}
        <Collapse in={subOpen} timeout="auto">
          <List component="div" disablePadding>
            <ListItem
              button
              onClick={startTour}
              style={{ color: '#546e7a', fontSize: '12px' }}
            >
              {jRID &&
                `${jRID.charAt(0).toUpperCase() + jRID.slice(1)} Tutorial`}
            </ListItem>
          </List>
        </Collapse>
      </Menu>
    </div>
  );
}
